import './DatasetsUploadDropdown.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown, faHome, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { ClickAwayListener } from '@mui/base';
import { Button, Dropdown, IconButton, Menu, MenuButton, MenuItem } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { S_ClipLoader } from '../../design/loaders/clipLoader/S_ClipLoader';
import { IDatasetsUploadDropdownProps } from '../containers/DatasetsUploadDropdown.container';
import { getProgressPercent } from '../helpers/number.helpers';
import { ConfirmationModal } from './ConfirmationModal';
import { ProgressBar } from './ProgressBar';

library.add(faTimes, faHome);

const MenuItemWithProgressBar = observer(
  (props: { progress: number; id: string; name: string; hasAnyError: boolean; onCancelDatasetUploading(datasetId: string): void }): ReactElement => (
    <MenuItem
      key={props.id}
      className='datasets-single-item'
    >
      <div className='top'>
        <div className='name text-left'>{props.name}</div>
        <div className='current-progress text-right'>{props.progress}%</div>
      </div>
      <div className='bottom'>
        <ProgressBar
          success={!props.hasAnyError}
          value={props.progress}
        />
        <IconButton
          size='sm'
          color='danger'
          onClick={(): void => {
            props.onCancelDatasetUploading(props.id);
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </div>
    </MenuItem>
  )
);

export const DatasetsUploadDropdown = observer((props: IDatasetsUploadDropdownProps): ReactElement => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { t } = useTranslator();

  return (
    <>
      {props.queue.length > 0 && (
        <ClickAwayListener
          onClickAway={() => {
            setIsOpen(false);
          }}
        >
          <div className='top-nav-item'>
            <Dropdown open={isOpen}>
              <MenuButton
                onClick={() => {
                  setIsOpen((x) => !x);
                }}
                slots={{ root: Button }}
                slotProps={{
                  root: {
                    variant: 'topbar',
                    startDecorator: (
                      <S_ClipLoader
                        loading={true}
                        size={24}
                        color='currentColor'
                      />
                    ),
                    endDecorator: <FontAwesomeIcon icon={faChevronDown} />,
                  },
                }}
              >
                <span>{t('datasets_upload')}</span>
              </MenuButton>
              <Menu className='no-hover datasets-upload-menu'>
                {props.queue.map((ds) => (
                  <MenuItemWithProgressBar
                    key={ds.dataSetId}
                    progress={getProgressPercent(ds.uploadedCount, ds.allCount)}
                    id={ds.dataSetId}
                    name={ds.dataSetName}
                    hasAnyError={ds.hasAnyError}
                    onCancelDatasetUploading={ds.onShowConfirmationModal}
                  />
                ))}
              </Menu>
            </Dropdown>
          </div>
        </ClickAwayListener>
      )}
      <ConfirmationModal
        showModal={props.showModal}
        onConfirm={props.onConfirmCancel}
        onCancel={props.onResume}
        confirmationHeader='cancel_dataset_upload'
        confirmationQuestion='dataset_upload_cancelation_confirmation_question'
      />
    </>
  );
});
